export function stringToBoolean(value) {
    const boolMap = {
        'true': true,
        'false': false
    };
    return boolMap[value];
}
